import { createClient } from 'redis';
import type { CacheStrategy } from '../../types/index.d.ts';

class RedisCacheStrategy implements CacheStrategy {
    private client;

    constructor(redisUrl = 'redis://localhost:6379') {
        this.client = createClient({ url: redisUrl });
        this.client.connect().catch(console.error);
    }

    async set(
        key: string,
        value: string,
        cache: boolean,
        ttl: number,
    ): Promise<void> {
        if (cache) {
            await this.client.setEx(key, ttl, value);
        } else {
            await this.client.set(key, value);
        }
    }

    async get(key: string): Promise<string | null> {
        return await this.client.get(key);
    }

    async delete(key: string): Promise<void> {
        await this.client.del(key);
    }
}

export default RedisCacheStrategy;
